import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Style from "../../../../../styles/js/StyleCallList.js";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';

import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from "date-fns/locale/es";

import alerter from "../../../../alerts/alerter"
import service from '../../../../../plas/services/calls/service';
import { Call } from '../../../../../plas/services/calls/models';
import ConfigurationSelector from './configuration-selector';

export default function CallDetails( { call, disable, disabled } ) {

  const [actualCall, setActualCall] = React.useState(new Call(call));
  const [originalCall, setOriginalCall] = React.useState(new Call(call));
  const [editing, setEditing] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);

  const [startDate, setStartDate] = React.useState(new Date(call.startDate));
  const [endDate, setEndDate] = React.useState(new Date(call.endDate));

  const style = Style();

  const startEditing = () => {
    setEditing(true);
  }

  const stopEditing = () => {
    setActualCall(new Call(originalCall));
    setEditing(false);
  }
  
  const saveChanges = () => {
    disable(true);
    setUpdating(true);

    var newDetails = { 
      id: actualCall.id, 
      name: actualCall.name, 
      description: actualCall.description,
    }

    if (actualCall.canChangeConfiguration())
      newDetails['configurationId'] = actualCall.configurationId;

    if (actualCall.canChangeStartDate()) 
      newDetails['startDate'] = actualCall.startDate;

    if (actualCall.canChangeEndDate()) 
      newDetails['endDate'] = actualCall.endDate;

    service.api.calls.update(actualCall.id, newDetails, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setEditing(false);
        setOriginalCall(actualCall);
        Object.assign(call, actualCall);
      }
      
      setUpdating(false);
      disable(false)
    });
  }

  return (
    <div className={style.box} >
      <Card style={{ marginBottom: "15px"}}>
        <div className={style.itemHeader}>
          <Typography className={style.titleInitial}>
            Detalles
          </Typography>
          <div style={{ marginLeft: 'auto' }} >
            { updating ? 
              (
                <IconButton disabled={true} aria-label="delete" style={{ color: 'white' }}>
                 <CircularProgress color="inherit" size={22}/>
                </IconButton>
              ) : (
                <div>
                { editing ? 
                  (
                    <div>
                      <Tooltip title="Cancelar">    
                        <IconButton aria-label="cancel" style={{ color: 'white' }} onClick={ () => { stopEditing() }}>
                          <CancelIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Confirmar">    
                        <IconButton aria-label="confirm" style={{ color: 'white' }} onClick={ () => { saveChanges() }}>
                          <ConfirmIcon fontSize="small"/>
                        </IconButton>
                      </Tooltip>
                    </div>
                  ) : 
                  ( 
                    <Tooltip title="Editar">    
                      <IconButton aria-label="edit" style={{ color: 'white' }} onClick={ () => { startEditing() }} >
                        <EditIcon fontSize="small"/>
                      </IconButton>
                    </Tooltip>
                  )
                }
                </div>
              )
            }
          </div>
        </div>
        <div style={{ textAlign:"left", padding: '12px'}}>
          <div className={style.itemContent}>
            <LocalizationProvider 
              adapterLocale={esLocale}
              dateAdapter={AdapterDateFns}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12}>
                      <TextField
                          variant="outlined" 
                          id="name"
                          label="Nombre"
                          name="name"
                          disabled={!editing || disabled}
                          value={actualCall.name}
                          onChange={ (event) => {
                            actualCall.name = event.target.value
                            setActualCall(new Call(actualCall));
                          }}
                          fullWidth
                          placeholder="Nombre de la convocatoria"/>
                      </Grid>
                      <Grid item xs={6}>
                        <DateTimePicker
                            label="Fecha de apertura"
                            disabled={(!editing) || (!actualCall.canChangeStartDate()) || disabled}
                            value={startDate}
                            minDate={new Date(actualCall.minStartDate())}
                            maxDate={endDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              actualCall.startDate = newValue.getTime()
                              setActualCall(new Call(actualCall));
                            }}
                            renderInput={(params) => <TextField fullWidth variant="outlined" {...params} />}>
                        </DateTimePicker>
                      </Grid>
                      <Grid item xs={6}>
                        <DateTimePicker
                            label="Fecha de cierre"
                            value={endDate}
                            disabled={(!editing) || (!actualCall.canChangeEndDate()) || disabled}
                            minDate={new Date(actualCall.minEndDate())}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              actualCall.endDate = newValue.getTime()
                              setActualCall(new Call(actualCall));
                            }}
                            renderInput={(params) => <TextField fullWidth variant="outlined" {...params} />}>
                        </DateTimePicker>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                            variant="outlined" 
                            id="description"
                            label="Descripción"
                            name="description"
                            disabled={!editing || disabled}
                            value={actualCall.description}
                            multiline
                            fullWidth
                            placeholder="Información acerca de la convocatoria"
                            onChange={(event) => {
                              actualCall.description = event.target.value
                              setActualCall(new Call(actualCall));
                            }}
                        />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} >
                      <ConfigurationSelector 
                        preSelect={actualCall.configuration}
                        disabled={!editing || !actualCall.canChangeConfiguration() || disabled}
                        select={ (configuration) => { 
                          actualCall.configurationId = configuration.id
                          actualCall.configuration = configuration
                          setActualCall(new Call(actualCall));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </LocalizationProvider>
          </div>
        </div>
      </Card>


    </div>

  );

}
